import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IncidentEditDialogData {
  message: string;
}

export interface IncidentEditDialogResult {
  message: string;
}

@Component({
  selector: 'app-incident-edit-dialog',
  templateUrl: './incident-edit-dialog.component.html',
  styleUrls: ['./incident-edit-dialog.component.css'],
})
export class IncidentEditDialogComponent {
  draft: string;

  constructor(
    public dialogRef: MatDialogRef<IncidentEditDialogComponent, IncidentEditDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: IncidentEditDialogData,
  ) {
    this.draft = data.message ?? '';
  }

  save(): void {
    this.dialogRef.close({ message: this.draft.trim() });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
